/* eslint-disable import/prefer-default-export */
import { injectLocal } from '@vueuse/core';
import { PRODUCT_FLAGS_REPOSITORY } from '../../product/constants';

export const useProductFlags = () => {
  const flags = injectLocal(PRODUCT_FLAGS_REPOSITORY);

  if (typeof flags === 'undefined') {
    throw new TypeError('useProductFlags() is called without provider.');
  }

  return flags;
};
